import { toolActivity } from '../../app-connection/types'
import { z } from 'zod'

export const stopAndRateConversationResult = z.object({
    toolActivities: toolActivity.array().default([]),
    message: z.string(),
    conversationLanguage: z.string().nullable().optional(),
    matchScore: z.number(),
    positiveCandidateAttributes: z.array(z.string()),
    negativeCandidateAttributes: z.array(z.string()),
})

export type StopAndRateConversationResult = z.infer<typeof stopAndRateConversationResult>
